import { Injectable } from "@angular/core";
import { DwdmDiagramAbstractConverterOscs } from "../../diagram/converter/dwdm-diagram-abstract-converter-osc";
import { OscsConverterData } from "../../diagram/converter/dwdm-diagram-converter.models";
import { OscElement, OscPositionMap } from "../../diagram/models/diagram.models";

/**
 * Implementação da @see DwdmDiagramAbstractConverterOscs para a wizard de criação de circuitos DWDM.
 */
@Injectable({
    providedIn: "root"
})
export class DwdmDiagramWizardConverterOscsService extends DwdmDiagramAbstractConverterOscs {

    /**
     * Converte a OSC de um END.
     * ENDs só podem ter uma OSC.
     */
    public convertForEnd(oscsData: OscsConverterData,): OscElement | null {
        return super.convertDataForEnd(oscsData, () => {});
    }

    /**
     * Converte as OSCs de um Intermediário.
     * Intermediários podem ter até 2 OSCs.
     */
    public convertForIntermediate(oscsData: OscsConverterData): OscPositionMap {
        return super.convertDataForIntermediate(oscsData, () => {});
    }

}
